// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"dashboard_imgWrapper__3VOkP"};